import React from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { cancelBooking } from 'redux/booking/travel/travelBookingSlice';
import { Modal, Button, Alert } from 'components/common';

const BookingCancelConfirmation = ({ showModal, setshowModal, booking }) => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const dispatch = useDispatch();

  const closeModal = () => setshowModal(false);

  const onSubmit = (data) => {
    try {
      dispatch(cancelBooking({ bookingId: booking.id, data }));
      closeModal();
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      title="Cancel Travel booking!"
      size="lg"
      footer={(
        <>
          <Button size="sm" variant="secondary" onClick={closeModal}>Cancel</Button>
          <Button size="sm" type="submit" form="travel-cancel-form" variant="danger">Submit</Button>
        </>
      )}
    >
      <form id="travel-cancel-form" onSubmit={handleSubmit(onSubmit)}>
        <Alert type="info" className="tw-mb-4">You are only allowed to cancel a booking when it has not been approved. You must specify the reason for the cancellation.</Alert>
        <label className="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Reason</label>
        <textarea rows={6} placeholder="Reason"
          className="tw-w-full tw-px-3 tw-py-2 tw-border tw-border-solid tw-border-slate-300 tw-rounded-md tw-text-sm tw-text-slate-900 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
          {...register('reason', { required: 'Reason must be required' })} />
        {errors.reason && <p className="tw-text-xs tw-text-red-600 tw-mt-1 tw-mb-0">{errors.reason.message}</p>}
      </form>
    </Modal>
  );
};

BookingCancelConfirmation.propTypes = {
  showModal: PropTypes.bool,
  setshowModal: PropTypes.func,
  booking: PropTypes.object,
};

export default BookingCancelConfirmation;
